<template>
	<errorContainer :error="erreur" :warning="warning">
		<transition name="slide">
			<div class="app">
				<b-card header-tag="header" footer-tag="footer" class="p-0 w-100 m-0" style="height: 100vh">
					<template #header>
						<b-row class="d-flex align-items-center pl-4" style="gap: 10px">
							<h6 class="mb-0">{{ FormMSG(1, 'Viewer') }}</h6>
							<span>{{ `( ${filename} )` }}</span>
						</b-row>
					</template>
					<div class="h-100 w-100">
						<carousel
							:value="imageUrls"
							:num-visible="1"
							:num-scroll="1"
							:key="carouselImgUpd"
							orientation="vertival"
							contentClass="main-carousel"
							style="height: 100%"
						>
							<template #item="slotProps">
								<div class="product-item">
									<div class="product-item-content">
										<div class="parent cursor-pointer">
											<div v-if="getFileExtension(slotProps.data) !== 'pdf'" class="slide">
												<b-img-lazy
													:src="getImage(slotProps.data)"
													:alt="slotProps.data"
													fluid-grow
													style="border-radius: 8px; height: 100%"
													class="px-1"
												/>
											</div>
											<div v-else class="iframe-pdf">
												<iframe class="full full_h clearfix" :src="getImage(slotProps.data)" frameborder="0" />
											</div>
										</div>
									</div>
								</div>
							</template>
						</carousel>
					</div>
				</b-card>
			</div>
		</transition>
	</errorContainer>
</template>

<script>
// mixin
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
// components
import Carousel from 'primevue/carousel';
// utils
import { getFileExtension } from '@/shared/helpers';
INVOICE_ATTACHEMENTS_TYPE;
// constants
import { INVOICE_ATTACHEMENTS_TYPE } from '@/shared/constants';

export default {
	name: 'InvoiceFilesVIewer',
	mixins: [languageMessages, globalMixin],
	components: { Carousel },
	data() {
		return {
			imageUrls: [],
			carouselImgUpd: 0,
			filename: '',
			erreur: {},
			warning: ''
		};
	},
	async created() {
		await this.showLoader(this.provideDocSpecs, '', false);
	},
	methods: {
		getFileExtension(docXid) {
			return getFileExtension(docXid);
		},
		getImage(picture) {
			return process.env.VUE_APP_GQL + '/images/' + picture;
		},
		provideDocSpecs() {
			if (this.$route.query.doc) this.imageUrls.push(this.$route.query.doc);
			if (this.$route.query.label) this.filename = this.$route.query.label;
		}
	}
};
</script>
